import React, {useEffect} from 'react';
import styles from './Confirm.scss';
import Button from '@components/base/Button/Button';
import Portal from '@components/base/Portal/Portal';

const Confirm = ({
					 text = '',
					 color = '',
					 children = null,
					 confirmText = '',
					 onConfirm = null,
					 cancelText = '',
					 onCancel = null,
				 }) => {

	// Lock background scroll while the overlay is visible by locking ONLY <html>
	// (the real viewport scroller). We must NOT lock <body>: <html> has
	// `overflow-x: clip` (main.scss), which disables body->viewport overflow
	// propagation, so `body { overflow: hidden }` would turn <body> itself into a
	// scroll container. The tabs' position:sticky would then stick to <body>
	// (never scrolled, at page-top) instead of the viewport, so the docked tabs
	// jump off-screen and appear to vanish behind this (translucent) overlay.
	useEffect(() => {
		const html = document.documentElement;
		const prevHtml = html.style.overflowY;
		html.style.overflowY = 'hidden';
		return () => {
			html.style.overflowY = prevHtml;
		};
	}, []);

	// Cancel is required; Confirm is optional
	if (!cancelText || typeof onCancel !== 'function') {
		console.warn('Confirm notification layout requires `cancelText` and `onCancel`');
		return null;
	}
	const showConfirm = !!confirmText && typeof onConfirm === 'function';

	// Render via portal to escape any transformed/positioned ancestor containing block
	return (
	  <Portal containerId={'modalContainer'}>
		  <div
			className={styles.overlay}
			role="dialog"
			aria-modal="true">

			  <div className={styles.popup}>

				  <div className={styles.content}>
					  {children
						? children
						: <span dangerouslySetInnerHTML={{__html: text}}/>
					  }
				  </div>

				  <div className={styles.actions}>
					  <button
						type="button"
						className={styles.cancelLink}
						onClick={onCancel}>
						  {cancelText}
					  </button>

					  {showConfirm && (
						<Button
						  value={confirmText}
						  onClick={onConfirm}
						/>
					  )}
				  </div>
			  </div>
		  </div>
	  </Portal>
	);
};

export default Confirm;
